<template>

<com-content :blue="true" :center="!window.is.mobile" :grow="true" class="login">

	<div class="login-types">

        <div class="login-types-item">

            <app-icon icon="my.logo" class="login-icon" />

            <h2>Attendee</h2>

            <p>You are attending a convention and want to manage your profile, schedule, and more.</p>

            <app-button text="Login" v-on:click="onMyClick" />

        </div>

        <div class="login-types-item">

            <app-icon icon="manager.logo" class="login-icon" />

            <h2>Organiser</h2>

            <p>You are running a convention and want to manage all aspects of it.</p>

            <app-button text="Login" v-on:click="onManageClick" />

        </div>

    </div>

</com-content>
	
</template>

<script>

export default {

	components: {

		'com-content': () => import('./common/Content')

	},

    methods: {
    
        onMyClick: function() {
        
            window.location.href = process.env.VUE_APP_LOGIN_MY
        
        },
    
        onManageClick: function() {
        
            window.location.href = process.env.VUE_APP_LOGIN_MANAGE
        
        }
    
    }

}

</script>

<style scoped>

.login-icon {
	font-size: 96px;
	color: #fff;
	text-align: center;
}

.is-mobile .login-icon {
    font-size: 64px;
}

.login-icon >>> i {
	--fa-primary-color: #ffffff;
	--fa-secondary-color: #ffbe7a;
	--fa-secondary-opacity: 1;
} 

.login-logo {
	margin: 4px 0px;
}

.login-types {
    display: flex;
    max-width: 1120px;
}

.is-mobile .login-types {
    flex-direction: column;
    align-items: center;
    padding: 60px 0px 0px 0px;
}

.login-types-item {
    width: 50%;
    padding: 40px;
    text-align: center;
    display: flex;
    flex-direction: column;
}

.is-mobile .login-types-item {
    padding: 20px;
    width: 100%;
}

.login-types-item h2 {
    font-size: 28px;
    line-height: 28px;
    font-weight: 500;
    padding: 0px 10px;
    margin-top: 20px;
    text-align: center;
    color: #fff;
}

.login-types-item p {
    font-size: 16px;
    line-height: 20px;
    font-weight: 300;
    padding: 0px 10px;
    min-height: 40px;
    margin-top: 8px;
    text-align: center;
    color: #fff;
    margin-bottom: 40px
}

.is-mobile .login-types-item p {
    margin-bottom: 20px;
    min-height: auto;
}

.login-types-item:nth-child(1) {
    border-right: 1px solid rgba(255, 255, 255, 0.25);
}

.is-mobile .login-types-item:nth-child(1) {
    border: 0px;
}

</style>